import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './ProjectsNav.css';

const ProjectsNav = () => {
    const [isOpen, setIsOpen] = useState(false);

    const featuredProjects = [
        { name: 'All Seasons Landscaping', path: '/AllSeasons' },
        { name: 'Variety DC Charity Redesign', path: '/Variety' },
        { name: 'Hyker Travel Platform', path: '/Hyker' }
    ];

    const academicProjects = [
        { name: 'Government Website Redesign', path: '/Govt' },
        { name: 'Plantagochi App', path: '/Case1' },
        { name: 'Hitch Travel App', path: '/Hitch' }
    ];

    return (
        <div
            className="projects-dropdown"
            onMouseEnter={() => setIsOpen(true)}
            onMouseLeave={() => setIsOpen(false)}
        >
            <button className="dropdown-toggle" type="button">
                PROJECTS
            </button>
            <div className={`dropdown-menu ${isOpen ? 'show' : ''}`}>
                <div className="dropdown-section">
                    <span className="dropdown-header">Featured Work</span>
                    {featuredProjects.map((project, index) => (
                        <Link
                            key={`featured-${index}`}
                            to={project.path}
                            className="dropdown-item"
                            onClick={() => setIsOpen(false)}
                        >
                            {project.name}
                        </Link>
                    ))}
                </div>
                <div className="dropdown-divider"></div>
                <div className="dropdown-section">
                    <span className="dropdown-header">Academic Projects</span>
                    {academicProjects.map((project, index) => (
                        <Link
                            key={`academic-${index}`}
                            to={project.path}
                            className="dropdown-item"
                            onClick={() => setIsOpen(false)}
                        >
                            {project.name}
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ProjectsNav;
